import Styled from "styled-components";
import { Modal } from "antd"


export const Instructions = Styled.span`

    font-size: 0.8rem;
    
`
export const ChatBoxModal = Styled(Modal)`

    position: relative;
    top: 40px;
    
`



export const ChatBoxWrapper = Styled.div`

    display: grid;
    grid-template-columns: 1fr;
    width: 420px;
    height: 250px;
    border: 1px solid gray;
    border-radius: 10px 10px 10px 10px;
    margin: 20px;

`

export const ChatMessages = Styled.div`

    display: grid;
    grid-template-columns: 1fr;
    width: 400px;
    height: auto;
    margin: 10px;
    overflow-y: scroll;
`
export const InputWrapper = Styled.div`

    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    border: 1px solid gray;
    border-radius: 10px 10px 10px 10px;
    width: 420px;
    height: 60px;
    margin: 20px;
`
export const InputButtons = Styled.div`

    display: grid;
    grid-template-columns: 3fr 1fr;
    gap:5px;
    width: 400px;
    height: 40px;
    margin: 5px;
`
